/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// https://raw.githubusercontent.com/cowboy/jquery-resize/v1.1/jquery.ba-resize.min.js
(function($,h,c){var a=$([]),e=$.resize=$.extend($.resize,{}),i,k="setTimeout",j="resize",d=j+"-special-event",b="delay",f="throttleWindow";e[b]=250;e[f]=true;$.event.special[j]={setup:function(){if(!e[f]&&this[k]){return false}var l=$(this);a=a.add(l);$.data(this,d,{w:l.width(),h:l.height()});if(a.length===1){g()}},teardown:function(){if(!e[f]&&this[k]){return false}var l=$(this);a=a.not(l);l.removeData(d);if(!a.length){clearTimeout(i)}},add:function(l){if(!e[f]&&this[k]){return false}var n;function m(s,o,p){var q=$(this),r=$.data(this,d);r.w=o!==c?o:q.width();r.h=p!==c?p:q.height();n.apply(this,arguments)}if($.isFunction(l)){n=l;return m}else{n=l.handler;l.handler=m}}};function g(){i=h[k](function(){a.each(function(){var n=$(this),m=n.width(),l=n.height(),o=$.data(this,d);if(m!==o.w||l!==o.h){n.trigger(j,[o.w=m,o.h=l])}});g()},e[b])}})(jQuery,this);

// 待优化
 var autoViewportResize = function() {
    var viewports = document.querySelectorAll(".flickity-viewport");
    viewports.forEach(function(viewport){
      var items = viewport.querySelectorAll(".product-item");
      var maxHeight = 0.0;
      items.forEach(function(item) {
        if (maxHeight < item.offsetHeight) {
        	maxHeight = item.offsetHeight;
        }
      })
      viewport.style.height = maxHeight + "px";
    })
}

// cookies
function setCookie(name, value, seconds) {
    var exp = new Date();
  	exp.setTime(exp.getTime()+(seconds*1000));
    document.cookie = name + "=" + encodeURIComponent(value)+";expires="+exp.toUTCString();
}

function getCookie(name) {
    var arr, reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) 
        return decodeURIComponent(arr[2]);
    else
        return null;
}

function delCookie(name) {
    var val = getCookie(name);
    if (val == null) {
        return 
    }
    setCookie(name, val, -1)
}

// 替换logo
function replaceLogo() {
  var imgs = {
    "https://www.civivi.com/": "https://cdn.shopify.com/s/files/1/0345/1112/6660/files/civivi_logo.png?v=1645781491",
    "active-https://www.civivi.com/": "https://cdn.shopify.com/s/files/1/0345/1112/6660/files/civivi_logo_active.png?v=1645781491",
    "https://www.weknife.com/": "https://cdn.shopify.com/s/files/1/0345/1112/6660/files/we_logo.png?v=1645781472",
    "active-https://www.weknife.com/": "https://cdn.shopify.com/s/files/1/0345/1112/6660/files/we_logo_active.png?v=1645781472",
    "https://weknife.myshopify.com/": "https://cdn.shopify.com/s/files/1/0345/1112/6660/files/we_logo.png?v=1645781472",
    "active-https://weknife.myshopify.com/": "https://cdn.shopify.com/s/files/1/0345/1112/6660/files/we_logo_active.png?v=1645781472",
  }
  $(".footer__link-item").each(function(index, item) {
    for (var key in imgs) {
      if (item.href == key) {
        item.parentElement.style.display = "inline-block";
        item.textContent = "";
        item.style.paddingRight = "5px";
        item.parentNode.style.paddingTop = "5px"
        
        var img = document.createElement("img");
        item.appendChild(img);
        img.src = imgs[key];
        img.id = "footer-brand-"+ index
        if (key == "https://www.civivi.com/") {
          img.style.width = "51px";
        } else {
          img.style.width = "60px";
        }
        var src = imgs[key]
        var activeSrc = imgs["active-"+key]
        item.onmouseover = function() {
          this.childNodes[0].src = activeSrc
        }
        item.onmouseout = function() {
          this.childNodes[0].src = src
        }
      }
    }
  })
}

function openLoginModal() {
  $("#customer_login_link").trigger("click");
}


function openRegisterModal() {
  $("#customer_register_link").trigger("click");
}